<template>
  <DataTable
    v-redirect-if-no-permission:TYPES
    :url="api.ACTIONS.CAR_BRANDS"
    :titles="titles"
    :fieldsHiddenMain="['deleted_at']"
    :fieldsHiddenAdd="['id', 'created_at', 'deleted_at', 'updated_at']"
    :fieldsDisabledEdit="['id', 'created_at', 'deleted_at', 'updated_at']"
    :actionsExtraMain="actionsExtraMain"
    :title="$t('drivers.carBrands.carBrands')"
    :fieldsExtraAdd="fieldsExtraAdd"
    :formatter="formatter"
  />
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

export default {
  name: "CarBrands",
  title() {
    return this.$t("drivers.carBrands.title");
  },
  components: { DataTable },
  computed: {
    titles() {
      return {
        id: "#",
        name: this.$t("common.name"),
        created_at: this.$t("drivers.carBrands.dateCreated"),
        updated_at: this.$t("drivers.carBrands.dateUpdated"),
      };
    },
    fieldsExtraAdd() {
      return {
        name: "v-text-field",
      };
    },
    actionsExtraMain() {
      return {
        models: {
          title: this.$t("drivers.carBrands.models"),

          color: "secondary",
          action: (item) =>
            this.$router.push({
              name: "CarBrandModels",
              params: { id: item.id },
              query: { name: item.name },
            }),
        },
      };
    },
    formatter() {
      return {
        created_at: (value) => moment(value).format("DD-MM-YYYY - HH:mm"),
        updated_at: (value) => moment(value).format("DD-MM-YYYY - HH:mm"),
      };
    },
  },
};
</script>

<style scoped></style>
